import createIcon from '../../createIcon';

/**
 * @component @name OpenInBrowser
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgNEg1QzMuODkgNCAzIDQuOSAzIDZWMThDMyAxOS4xIDMuODkgMjAgNSAyMEg5VjE4SDVWOEgxOVYxOEgxNVYyMEgxOUMyMC4xIDIwIDIxIDE5LjEgMjEgMThWNkMyMSA0LjkgMjAuMTEgNCAxOSA0Wk0xMiAxMEw4IDE0SDExVjIwSDEzVjE0SDE2TDEyIDEwWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const OpenInBrowser = createIcon('OpenInBrowser', [
  [
    'path',
    {
      d: 'M19 4H5C3.89 4 3 4.9 3 6V18C3 19.1 3.89 20 5 20H9V18H5V8H19V18H15V20H19C20.1 20 21 19.1 21 18V6C21 4.9 20.11 4 19 4ZM12 10L8 14H11V20H13V14H16L12 10Z',
      key: 'ibjehu',
    },
  ],
]);

export default OpenInBrowser;
